const motionEvent = (name, target) => new CustomEvent(name, { detail: { target } });
function dispatchPointerEvent(element, name, event) {
    element.dispatchEvent(new CustomEvent(name, { detail: { originalEvent: event } }));
}
function dispatchViewEvent(element, name, entry) {
    element.dispatchEvent(new CustomEvent(name, { detail: { originalEntry: entry } }));
}

export { dispatchPointerEvent, dispatchViewEvent, motionEvent };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/dom/dist/state/utils/events.es.js
// module id = YJ2Y
// module chunks = 0